import { LogoWithBadge } from "./LogoWithBadge";
import { formatDisplayAmount } from "../lib/formatDisplayAmount";

type Props = {
  label: string;
  amount: string;
  currencySymbol: string;
  amountUSD?: string;
  currencyLogoUrl: string;
  chainLogoUrl?: string;
  className?: string;
};

export function AmountDisplay({
  label,
  amount,
  currencySymbol,
  amountUSD,
  currencyLogoUrl,
  chainLogoUrl,
  className = "",
}: Props) {
  return (
    <div className={className}>
      <div className="text-xs text-[--color-text-secondary]">{label}</div>
      <div className="flex items-center justify-between">
        <div className="mt-1 text-4xl text-[--color-text-primary]">
          {formatDisplayAmount(amount)} {currencySymbol}
        </div>
        <div>
          <LogoWithBadge
            logoUrl={currencyLogoUrl}
            badgeUrl={chainLogoUrl}
            size="lg"
          />
        </div>
      </div>
      {amountUSD ? (
        <div className="text-sm text-[--color-text-secondary]">
          $
          {Number(amountUSD).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      ) : null}
    </div>
  );
}
